import PropTypes from 'prop-types';
import React from 'react';

import { Row } from 'twyne-new.ui';

import AuditResultBodyItem from './AuditResultBodyItem';

const AuditResultBody = ({ impression }) => {
  if (!impression) {
    return null;
  }

  return (
    <Row>
      <AuditResultBodyItem label="E-mail" value={impression.user.email} />
      <AuditResultBodyItem label="Birthday" value={impression.user.dob} />
      <AuditResultBodyItem label="Address" value={impression.user.address1} />
      <AuditResultBodyItem label="City" value={impression.user.city} />
      <AuditResultBodyItem label="State" value={impression.user.state} />
      <AuditResultBodyItem label="Zip" value={impression.user.zip} />
    </Row>
  );
}

AuditResultBody.propTypes = {
  impression: PropTypes.object,
};

export default AuditResultBody;
